import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function triggerGradientOnBgChange() {
  const body = document.body;
  const bgChangeTrigger = document.querySelector(".bg-change-trigger");

  if (!bgChangeTrigger) {
    // If there's no element with class "bg-change-trigger", exit the function
    return;
  }

  // Set up ScrollTrigger to add the class when bgChangeTrigger is passed
  ScrollTrigger.create({
    trigger: bgChangeTrigger,
    start: "top top", // When the top of bgChangeTrigger hits the top of the viewport
    end: "bottom top", // When the bottom of bgChangeTrigger hits the top of the viewport
    onEnter: () => body.classList.add("scrolled-gradient"), // Apply class when the trigger enters the viewport
    onLeaveBack: () => body.classList.remove("scrolled-gradient"), // Remove the class when scrolling back above it
    // When scrolling down past the element, keep the class on the body
    onEnterBack: () => body.classList.add("scrolled-gradient"),
    // Ensure the class is added even on refresh below the trigger point
    onLeave: () => {
      if (ScrollTrigger.isInViewport(bgChangeTrigger, "top")) {
        // No need to remove the class since we want it to persist below the trigger
        body.classList.add("scrolled-gradient");
      }
    },
  });

  // Immediately check if the page is already scrolled past the trigger on load
  if (
    window.scrollY >
    bgChangeTrigger.getBoundingClientRect().top + window.scrollY
  ) {
    body.classList.add("scrolled-gradient");
  }
}

export { triggerGradientOnBgChange };

function triggerHeaderScroll() {
  let lastKnownScrollPosition = 0;
  let ticking = false;

  function doSomething(scrollPos) {
    const body = document.body;

    if (scrollPos > 200) {
      body.classList.add("scrolled");
    } else {
      body.classList.remove("scrolled");
    }
  }

  window.addEventListener(
    "scroll",
    function (e) {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          doSomething(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    },
    { passive: true }
  );
}

export { triggerHeaderScroll };

function triggerGradientScroll() {
  let lastKnownScrollPosition = 0;
  let ticking = false;

  function doSomething(scrollPos) {
    const body = document.body;

    if (scrollPos > 1000) {
      body.classList.add("scrolled-gradient");
    } else {
      body.classList.remove("scrolled-gradient");
    }
  }

  window.addEventListener(
    "scroll",
    function (e) {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          doSomething(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    },
    { passive: true }
  );
}

export { triggerGradientScroll };
